import { Component } from '@angular/core';

@Component({
  selector: 'bb-footer',
  templateUrl: './footer.component.html',
  standalone: false,
})
export class FooterComponent {
  currentYear = new Date().getFullYear();
}
